import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate } from 'react-router-dom'

async function setStatusBar(color, style) {
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar')
    await StatusBar.setBackgroundColor({ color })
    await StatusBar.setStyle({ style: style === 'LIGHT' ? Style.Light : Style.Dark })
  } catch {}
}

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    setStatusBar('#4f46e5', 'LIGHT')
    return () => setStatusBar('#ffffff', 'DARK')
  }, [])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        supabase.from('users').select('role').eq('id', session.user.id).single().then(({ data }) => {
          if (data?.role === 'clinician') navigate('/clinician')
          else if (data?.role === 'patient') navigate('/patient')
        })
      }
    })
  }, [])

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) { setError(error.message); setLoading(false); return }
    const { data: profile } = await supabase.from('users').select('role').eq('id', data.user.id).single()
    if (profile?.role === 'clinician') navigate('/clinician')
    else navigate('/patient')
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #3730a3 100%)', padding: '1.5rem', paddingTop: 'max(1.5rem, env(safe-area-inset-top))', paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '2rem 2rem 1.5rem', background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
          <p style={{ fontWeight: 800, fontSize: 20, color: 'white', letterSpacing: -0.5, margin: '0 0 1rem' }}>Complete PT</p>
          <p style={{ fontSize: 24, fontWeight: 700, color: 'white', lineHeight: 1.2, letterSpacing: -0.5, margin: '0 0 0.5rem' }}>Welcome back</p>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, margin: 0 }}>Sign in to your account</p>
        </div>

        <div style={{ padding: '2rem' }}>
          {error && <div className="alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
          <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 8, padding: '10px 14px', marginBottom: '1rem' }}>
            <p style={{ fontSize: 13, color: '#92400e', margin: 0, lineHeight: 1.5 }}>
              <strong>Beta program:</strong> Please do not enter real patient data. This app is still in testing.
            </p>
          </div>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="form-field">
              <label className="form-label">Email address</label>
              <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-field">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <label className="form-label" style={{ margin: 0 }}>Password</label>
                <span onClick={() => navigate('/forgot-password')} style={{ fontSize: 13, color: 'var(--brand)', cursor: 'pointer', fontWeight: 500 }}>
                  Forgot password?
                </span>
              </div>
              <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" disabled={loading} style={{ marginTop: 4, padding: 14, fontSize: 15 }}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <div style={{ borderTop: '1px solid var(--border)', marginTop: '1.5rem', paddingTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <p style={{ textAlign: 'center', margin: 0 }}>
              New patient?{' '}
              <span onClick={() => navigate('/signup')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>
                Create an account
              </span>
            </p>
            <p style={{ textAlign: 'center', margin: 0 }}>
              Are you a clinician?{' '}
              <span onClick={() => navigate('/signup/clinician')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>
                Set up your clinic
              </span>
            </p>
          </div>
        </div>
      </div>

      <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
        <a href="https://completept.app/privacy.html" target="_blank" style={{ color: 'rgba(255,255,255,0.5)' }}>Privacy Policy</a>
        {' · '}
        <a href="mailto:sales@completept.app" style={{ color: 'rgba(255,255,255,0.5)' }}>Contact</a>
      </p>
    </div>
  )
}
